export const DAILY_SHOW_TITLE = 'TITV Daily Show';
export const VIEW_ALL_TEXT = 'View all';
